import { Constants } from '@src/app/commons/Constants';
import { DEBUG } from '@src/DEBUG';
DEBUG.open ( '/xs/controllers/base-class' );

/*
  PluginControls handles the various controls, knobs and dials a plugin might need the user to tweak
*/

export class XsBaseClass {

  debug:boolean = Constants.debug_off;
  debugStyle:string = 'color:#fff;background-color:#921;';
  debugId:string = 'BASE';
  parentClass:string = null;

  // our config
  _config:any = {};

  // our property store
  _props:any = {};

  constructor ( config:any = {}, defaults:any = null ) {

    this.parentClass = this.constructor.name;

    DEBUG.log ( '/xs/controllers/base-class' );

    if ( this['_config_default'] ) {
      this.__config(this['_config_default']);
    }

    if ( defaults ) {
      this.__config(defaults);
    }

    if ( config ) {
      this.__config(config);
    }
  }

  /* getters, setters, and Proxy wrapping implementation classes */

  __getset ( key:string ) {
    const me = this;
  }

  __getter ( key:string ) {
    const me = this;
    // console.log('C.get('+key+')', me[key], me[key] ? me[key]['__xs_prop'] : false );
    if ( ! me.hasOwnProperty(key) ) {
      me[key] = { value: null, __xs_prop:true };
    }
    if ( me[key] && me[key]['__xs_prop'] ) {
      return { value: me[key].value };
    }
    return me[key];
  }

  __setter ( key:string, value:any ) {
    const me = this;
    if ( ! me.hasOwnProperty(key) ) {
      me[key] = { value: value, __xs_prop:true };
    }
    if ( me[key] && me[key]['__xs_prop'] ) {
      me[key] = { value: value, __xs_prop:true };
    } else {
      me[key] = value;
    }
    // console.log('C.set('+key+')',me[key]);
    return true;
  }

  __proxyFactory() {
    const me = this;
    return new Proxy ( me, {
      set ( object, key:string, value:any ) {
          return me.__setter (key, value );
      },
      get ( object, key:string ) {
        return me.__getter ( key );
      }
    });
  }  

  /* configure our class */

  __config ( config:any = null ) {
    Object.keys(config).forEach(k => {
        if ( config.hasOwnProperty(k) ) {
            this._config[k] = config[k];
        }
    });
  }

  __props ( props:any = null ) {
    Object.keys(props).forEach(k => {
        if ( props.hasOwnProperty(k) ) {
            this._props[k] = props[k];
        }
    });
  }

  /* debug our class */

  __log ( funcy:string = '??', data:any = '' ) {
    if ( this.debug ) { 
      console.log ( '%c __'+this.debugId+' %c '+funcy+' %c '+this.parentClass+' ', Constants._red, Constants._black, Constants._gray, data ); 
    }
  }

  __uuidv4( token:string = '-', prefix:string = '') {
    return ( prefix + 'xxxxxxxx'+token+'xxxx'+token+'4xxx'+token+'yxxx'+token+'xxxxxxxxxxxx').replace(/[xy]/g, function(c) {
        var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
  }

  // reach sets properties of the current object (this) according to a path (delimited by '.');
  //  - reach ( 'myProp', value ) = this.myProp = value
  //  - reach ( 'someObj.subObj.myValue', value ) = this.someObj.subObj.myValue = value
  
  __reach ( sofar:any = null, path:string = '', data = null ) {
    if ( !sofar ) {
      return null;
    }
    if ( path.indexOf('.') !== -1 ) {
      let token = path.split('.')[0];
      let after = path.substring(path.indexOf('.') + 1);
      return this.__reach ( sofar[token], after, data );
    } else {
      if ( data ) {
        sofar[path] = data;
      }
      return sofar[path];
    } 
  }
}

